import { observer } from 'mobx-react-lite'
import { providerLogo, formatNumber } from '../../../../../../utils/Helper'
import React, { useMemo, useState, useContext } from 'react'
import AddActionModal from './InfluencerHeader/AddActionModal'
import axiosService from '../../../../../../utils/AxiosService'
import { useParams } from 'react-router-dom'
import { toastError } from '../../../../../FormComponents/Toasts'
import { isInfluencerVisibleInBudgetScenario, setInfluencerVisibleInBudgetForScenario } from '../influencerBudgetVisibility'
import Action from '../../../../../../models/Action'
import CampaignScenarioActionGroup from '../../../../../../models/CampaignScenarioActionGroup'
import DropdownButton from '../../../../../FormComponents/DropdownButton'
import Switch from '../../../../../FormComponents/Switch'
import { CampaignContext } from '../../../../../../contexts/CampaignContext'
import { useReadOnly } from '../../../../../../contexts/ReadOnlyContext'

export default observer(function InfluencerHeader({ influencer, campaignScenario, dropdownOpen, setDropdownOpen }) {
  const { id } = useParams()
  const readOnly = useReadOnly()
  const { campaignState, campaign, authentications, primaryScenarioId } = useContext(CampaignContext)
  const [modalOpen, setModalOpen] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const totalSocialGroup = useMemo(() => campaignScenario.campaign_scenario_action_groups.find(actionGroup => actionGroup.influencer_id === influencer.id && actionGroup.action_type === 'total_social'), [campaignScenario.campaign_scenario_action_groups, campaignScenario.campaign_scenario_action_groups.length])
  const hasActions = campaignScenario.actions.some(action => action.influencer_id === influencer.id)

  const influencerActionGroups = campaignScenario.campaign_scenario_action_groups.filter(actionGroup => actionGroup.influencer_id === influencer.id)

  const isVisibleInBudget = isInfluencerVisibleInBudgetScenario(campaignScenario, influencer, campaign, authentications)

  const getProviderColor = provider => ({
    instagram: 'text-pink-600',
    tiktok: '',
    youtube: 'text-red-500'
  }[provider])

  const createAction = async ({ action_type, authentication_id, name }) => {
    setSubmitting(true)
    if(!totalSocialGroup) await createTotalSocial()
    let mediaActionGroup = campaignScenario.campaign_scenario_action_groups.find(actionGroup => actionGroup.influencer_id === influencer.id && actionGroup.action_type === action_type)
    if(!mediaActionGroup) await createActionGroup(action_type)
    mediaActionGroup = campaignScenario.campaign_scenario_action_groups.find(actionGroup => actionGroup.influencer_id === influencer.id && actionGroup.action_type === action_type)
    const authentication = authentication_id
      ? influencer.authentications.find(auth => auth.id === authentication_id)
      : null
    const payload = {
      influencer_id: influencer.id,
      action_type,
      name: name || (action_type === 'other_item' ? mediaActionGroup?.label || '' : ''),
      campaign_scenario_action_group_id: mediaActionGroup.id,
    }
    if (action_type === 'other_item') {
      payload.provider = 'other'
    } else if (authentication) {
      payload.provider = authentication.provider
      payload.authentication_id = authentication_id
    }
    axiosService.post(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/actions`, payload)
    .then(action => {
      campaignScenario.actions.push(new Action(action))
      setSubmitting(false)
      setModalOpen(false)
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const createActionGroup = async action_type => {
    return axiosService.post(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/campaign_scenario_action_groups`, { campaign_scenario_action_group: { influencer_id: influencer.id, action_type: action_type } })
    .then(actionGroup => {
      campaignScenario.campaign_scenario_action_groups.push(new CampaignScenarioActionGroup(actionGroup))
      return
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const createTotalSocial = async () => {
    return axiosService.post(`/api/project_manager/campaigns/${id}/campaign_scenarios/${primaryScenarioId}/campaign_scenario_action_groups`, { campaign_scenario_action_group: { influencer_id: influencer.id, action_type: 'total_social' } })
    .then(actionGroup => {
      campaignScenario.campaign_scenario_action_groups.push(new CampaignScenarioActionGroup(actionGroup))
    })
    .catch(({ data: { error }}) => toastError(error))
  }

  const toggleVisibleInBudget = event => {
    const newValue = event ? event.target.checked : !isVisibleInBudget
    setInfluencerVisibleInBudgetForScenario({
      campaignId: id,
      scenarioId: primaryScenarioId,
      campaignScenario,
      influencer,
      newValue,
      campaignState,
    }).catch(() => {})
  }

  return (
    <div key={influencer.id} className="p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <img className="h-12 w-12 rounded-full" src={influencer.authentications?.[0]?.avatar} alt=""/>
          <div className="ml-4">
            <div className="flex items-center gap-4">
              <p className="font-bold mb-1 dark:text-white">{influencer.full_name || influencer.authentications?.[0]?.username}</p>
              <div className="mt-1"><Switch name="visible_in_budget" value={isVisibleInBudget} onChange={toggleVisibleInBudget} /></div>
              { influencer.authentications?.map(authentication => (
                <div key={authentication.id} className="flex items-center gap-2 border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg py-1 px-2">
                  <div className={`${getProviderColor(authentication.provider)}`}>{providerLogo(authentication.provider)}</div>
                  <div className="flex flex-col leading-tight">
                    <p className="text-sm dark:text-white">{authentication.username}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex items-center gap-4">
              { influencer.authentications?.map(authentication =>
                <div key={authentication.id} className="flex items-center gap-2 border-1 border-border-primary dark:border-rb-dark-mode-lighter rounded-lg py-1 px-2">
                  <div className={`${getProviderColor(authentication.provider)}`}>{providerLogo(authentication.provider)}</div>
                  <div className="flex flex-col leading-tight">
                    <p className="text-sm dark:text-white">{authentication.username}</p>
                    <p className="text-sm dark:text-white">{formatNumber(authentication.reach)}</p>
                    <p className="text-sm text-rb-mat-grey dark:text-gray-400">{authentication.username}</p>
                    {authentication.initial_reach !== undefined && authentication.initial_reach !== null && authentication.initial_reach !== 0 && (
                      <p className="text-xs text-gray-500 dark:text-gray-400">{`Initial: ${formatNumber(authentication.initial_reach)}`}</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="flex">
          {!readOnly && <button className="bg-rb-green text-white p-2 px-3 rounded-md dark:text-rb-dark-mode" onClick={() => setModalOpen(true)}>Add Action +</button>}
          {hasActions && isVisibleInBudget && <DropdownButton dropdownOpen={dropdownOpen} setDropdownOpen={setDropdownOpen} className="ml-3" />}
        </div>
      </div>
      <AddActionModal createAction={createAction} authentications={influencer.authentications} isOpen={modalOpen} setIsOpen={setModalOpen} submitting={submitting} />
    </div>
  )
})